import React from 'react';
import './ListSymbols.css';
import Icon from '../home/Icon';
import Tooltip from '../tooltip/Tooltip';

// type: 0 = accent (blau), 1 = negative (rot), 2 = warning (gold)
const TYPE_TO_CLASS = { 0: 'accent', 1: 'negative', 2: 'warning' };

// tooltip (optional): Erklärung beim Hover (Desktop) — für Symbole, die nicht selbsterklärend sind.
function ListSymbol({icon = '', visible = false, type = 0, tooltip}) {
  const colorClass = TYPE_TO_CLASS[type] ?? 'accent';
  if (!visible) return null;
  const symbol = <Icon className={`listSymbolIcon ${colorClass}`} icon={icon} />;
  return tooltip ? <Tooltip text={tooltip}>{symbol}</Tooltip> : symbol;
}

export default ListSymbol
